import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { cssProp } from "./helpers";

const Centered = styled.div<{
	vertical?: boolean;
	horizontal?: boolean;
	gap?: string;
}>(
	({ vertical, horizontal, gap }) => css`
		display: flex;
		${!!vertical ? "align-items: center;" : ""}
		${!!horizontal ? "justify-content: center;" : ""}
		${cssProp("gap", gap)}
	`
);

export default Centered;
